import React from 'react';

export default function AdvancedToolbar({ children }: { children: React.ReactNode }) {
  return <div className="react-grid-Toolbar">{children}</div>;
}
